module.exports = function(bootstrap) {
    bootstrap.run(['Service', function(Service) {
        new Service(
            {
                name: 'visitedClaimsAndPayments',
                group: 'rbsmbl',
                cache: false,
                url: '/rbsmbl/x-services/updateMetrics/visitedClaimsAndPayments',

                fetch: function(userId) {
                    return this.get({ userId: userId });
                }
            }
        );
    }]);
};